module.exports = __webpack_public_path__ + "static/media/YF90_5.8091bdfb.jpg";